module.exports = __webpack_public_path__ + "img/ic-shuffle.2fa09c50.svg";